<template>
    <div>
        <v-simple-table v-if="data.selectedMembers.length > 0">
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">
                        #
                    </th>
                    <th class="text-left">
                        Član
                    </th>
                    <th class="text-left">
                        TIp člana
                    </th>
                    <!--<th class="text-left">
                        Vrsta člana
                    </th>-->
                    <th class="text-left">
                        Članarina
                    </th>
                    <th class="text-right">
                        CENA V EUR (Z DDV)
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(member, index) in data.selectedMembers" :key="index">
                    <td class="text-left">{{ index + 1}}</td>
                    <td class="text-left">{{ member.name + " "}}</td>
                    <td class="text-left">{{ (member.member_type !== null) ? member.member_type.name : "" }}</td>
                    <!--<td class="text-left">{{ (member.member_classification !== null) ? member.member_classification.name : "" }}</td>-->
                    <td class="text-left">{{  (member.membership_fee !== null) ? member.membership_fee.description : '' }}</td>
                    <td class="text-right">{{ (member.membership_fee !== null) ? new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(member.membership_fee.price)  : "0,00 €" }}</td>
                </tr>
                <br>
                <tr v-if="$vuetify.breakpoint.mdAndUp">
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td colspan="3" style="border-bottom:none;height:28px; font-weight:500" class="text-right">Operater: {{ $store.getters.user.name }}</td>
                </tr>
                <tr v-if="$vuetify.breakpoint.mdAndUp">
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td colspan="3" style="border-bottom:none;height:28px; font-weight:500" class="text-right">Datum in ura plačila: {{ currentDateTimeFormatted() }}</td>
                </tr>
                <tr v-if="$vuetify.breakpoint.mdAndUp">
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td colspan="3" style="border-bottom:none;height:28px; font-weight:500" class="text-right">Izbrano leto: {{ data.year }}</td>
                </tr>
                <tr v-if="$vuetify.breakpoint.mdAndUp">
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td colspan="3" style="border-bottom:none;height:28px; font-weight:500" class="text-right">Plačnik: {{ (data.selectedPayer.length > 0) ? data.selectedPayer[0].name : ""}}</td>
                </tr>
                <tr v-if="$vuetify.breakpoint.mdAndUp">
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <td style="border-bottom:none;height:28px;" class="text-left"></td>
                    <!--<td style="border-bottom:none;font-weight:500; height:28px;" class="text-right">Skupaj za plačilo: {{ new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(data.selectedMembershipFee.price) }}</td>-->
                    <td colspan="3" style="border-bottom:none;font-weight:500; height:28px;" class="text-right">Skupaj za plačilo: {{ new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(totalAmount()) }}</td>
                    
                </tr>
            </tbody>
            </template>
        </v-simple-table>
        
        <br v-if="$vuetify.breakpoint.mdAndDown">
        <br v-if="$vuetify.breakpoint.mdAndDown">
        <div v-if="$vuetify.breakpoint.mdAndDown">
            <p class="font-weight-bold body-1">Izbrano leto: {{ (data !== null) ?  data.year : "" }}</p>
            <p class="font-weight-bold body-1">Članarina: {{  (data !== null && data.selectedMembers.length > 0) ?  data.selectedMembers[0].membership_fee.name : "" }}</p>
            <p class="font-weight-bold body-1">Plačnik: {{ (data !== null && data.selectedPayer.length > 0) ? data.selectedPayer[0].name : ""}}</p>
            <!--<p class="font-weight-bold body-1">Skupaj za plačilo: {{ new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(data.selectedMembershipFee.price) }}</p>-->
            <p class="font-weight-bold body-1">Skupaj za plačilo: {{ new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(totalAmount()) }}</p>
        </div>

    </div>
</template>

<script>
import { EventBus } from '@/main.js'
import { formatDate, randomPinNumber, getCurrentDate } from '@/helpers/utilities.js'
import moment from 'moment'

export default {

    name: 'payment-info', 
    props: ['data'],

    data: () => ({
        interval1: null
    }),

    watch: {
        
    },

    computed: {

    },

    methods: {
        totalAmount() {
            let amount = 0.00;
            let selectedYear = this.data.year

            if(selectedYear < 2026) {
                this.data.selectedMembers.forEach(member => {
                    if(member.membership_fee) {
                        let membershipFeeId = member.membership_fee.id;
                        if(membershipFeeId == 1 || membershipFeeId == 2) {
                            amount += 7.00;
                        } else {
                            amount += member.membership_fee.price
                        }

                    }
                });
            } else {
                this.data.selectedMembers.forEach(member => {
                    amount += (member.membership_fee !== null) ?  member.membership_fee.price : 0;
                });
            }

            

            return amount;
        },

        currentDateTimeFormatted() {
            return moment().format("DD.MM.YYYY HH:mm:ss")
        }
    },

    created() {

    },

    mounted() {
        this.interval1 = setInterval(() => {
            //window.console.log("data:")
            //window.console.log(this.data)
        }, 3000)
    },

    beforeDestroy() {
        clearInterval(this.interval1)
    },

    destroyed() {

    }

}

</script>

<style scoped>

</style>